module.exports = __webpack_public_path__ + "img/6.4df13042.jpg";